export const LINKBUTTON = 'linkButton';
export const BUTTON = 'button';
export const SUBMIT = 'submitButton';
